@if (article) {
  {{ article.serial_number || '-' }}
  @if (article.rma) {
    ({{ article.rma }})
  }
}
